import { render, staticRenderFns } from "./Allesgo.vue?vue&type=template&id=f81f6a0c&scoped=true"
import script from "./Allesgo.vue?vue&type=script&lang=js"
export * from "./Allesgo.vue?vue&type=script&lang=js"
import style0 from "./Allesgo.vue?vue&type=style&index=0&id=f81f6a0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81f6a0c",
  null
  
)

export default component.exports